export interface TimeZoneOption { value: string; label: string }

export const AVAILABLE_TIMEZONES: TimeZoneOption[] = [
  { value: 'UTC', label: 'UTC' },
  { value: 'America/Argentina/Buenos_Aires', label: 'UTC-03:00' },
  { value: 'America/Sao_Paulo', label: 'UTC-03:00 / -02:00' },
  { value: 'America/New_York', label: 'UTC-05:00 / -04:00' },
  { value: 'America/Chicago', label: 'UTC-06:00 / -05:00' },
  { value: 'America/Denver', label: 'UTC-07:00 / -06:00' },
  { value: 'America/Los_Angeles', label: 'UTC-08:00 / -07:00' },
  { value: 'Europe/London', label: 'UTC+00:00 / +01:00' },
  { value: 'Europe/Madrid', label: 'UTC+01:00 / +02:00' },
  { value: 'Europe/Berlin', label: 'UTC+01:00 / +02:00' },
  { value: 'Europe/Paris', label: 'UTC+01:00 / +02:00' },
  { value: 'Europe/Zurich', label: 'UTC+01:00 / +02:00' },
  { value: 'Africa/Johannesburg', label: 'UTC+02:00' },
  { value: 'Asia/Dubai', label: 'UTC+04:00' },
  { value: 'Asia/Singapore', label: 'UTC+08:00' },
  { value: 'Asia/Tokyo', label: 'UTC+09:00' },
  { value: 'Australia/Sydney', label: 'UTC+10:00 / +11:00' }
];

// Legacy -> IANA
const LEGACY_TZ_MAP: Record<string, string> = {
  'UTC+0 (GMT)': 'UTC',
  'UTC+00 (GMT)': 'UTC',
  'UTC-3 (Argentina)': 'America/Argentina/Buenos_Aires',
  'UTC-03 (Argentina)': 'America/Argentina/Buenos_Aires',
  'UTC-5 (New York)': 'America/New_York',
  'UTC-05 (New York)': 'America/New_York',
  'UTC-8 (Los Angeles)': 'America/Los_Angeles',
  'UTC-08 (Los Angeles)': 'America/Los_Angeles'
  // agrega otros legacy detectados aquí
};

export function normalizeTimeZone(value?: string | null): string {
  if (!value) return 'UTC';
  if (AVAILABLE_TIMEZONES.some(t => t.value === value)) return value;
  if (LEGACY_TZ_MAP[value]) return LEGACY_TZ_MAP[value];
  return 'UTC';
}

export function getTimeZoneLabel(tzValue?: string): string {
  const v = normalizeTimeZone(tzValue);
  return AVAILABLE_TIMEZONES.find(t => t.value === v)?.label || 'UTC';
}